export default __webpack_public_path__ + "static/logo-48e36a59701cda3036fd546ce22e89ab.png";